<template>
  <div class="home">
    <div class="index">
      <div class="each-index">
        <div>
          <i class="el-icon-document"></i>
          <span>交易管理</span>
        </div>
        <span class="line">-----------------------------------------------</span>
        <div class="data">
          今日新增订单<span>{{ addOrderNum }}</span>
        </div>
      </div>
      <div class="each-index">
        <div>
          <i class="el-icon-document"></i>
          <span>退款管理</span>
        </div>
        <span class="line">-----------------------------------------------</span>
        <div class="data">
          新的退款申请<span>{{ refundNum }}</span>
        </div>
      </div>
      <div class="each-index">
        <div>
          <i class="el-icon-document"></i>
          <span>今日新增学校</span>
        </div>
        <span class="line">-----------------------------------------------</span>
        <div class="data">
          新的学校数量<span>{{ schoolNum }}</span>
        </div>
      </div>
      <div class="each-index last">
        <div>
          <i class="el-icon-document"></i>
          <span>今日总运费</span>
        </div>
        <span class="line">-----------------------------------------------</span>
        <div class="data">
          今日总运费金额<span>{{ freightNum }}</span>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="quota">
        <span>今日新增收款（元）</span>
        <p style="color:red">{{ information.todayAggregateAmount }}</p>
        <span>学校数（所）</span>
        <p>{{ information.schoolQuantity }}</p>
        <span>平台总流水（元）</span>
        <p>{{ information.aggregateAmount }}</p>
      </div>
      <div id="home-main"></div>
    </div>
    <div class="table-box">
      <table>
        <th :colspan="3">
          自有商品销量排行榜
        </th>
        <tr>
          <td style="width: 100px">排名</td>
          <td>商品名称</td>
          <td style="width: 200px">销售（件）</td>
        </tr>
        <tr v-for="(item, index) in rankingList" :key="index">
          <td style="width: 100px">{{ item.rownum }}</td>
          <td>{{ item.goodsName }}</td>
          <td style="width: 200px">{{ item.quantity }}</td>
        </tr>
      </table>
      <table>
        <th :colspan="3">
          平台推荐商品销量排行榜
        </th>
        <tr>
          <td style="width: 100px">排名</td>
          <td>商品名称</td>
          <td style="width: 200px">销售（件）</td>
        </tr>
        <tr v-for="(item, index) in platformList" :key="index">
          <td style="width: 100px">{{ index + 1 }}</td>
          <td>{{ item.goodsName }}</td>
          <td style="width: 200px">{{ item.quantity }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import request from '../utils/request';
import * as echarts from 'echarts';

export default {
  data() {
    return {
      addOrderNum: '',
      refundNum: '',
      freightNum: '',
      schoolNum: '',
      option: {
        title: {
          // text: 'Referer of a Website',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        color: ['#63CB63', '#ED7C30', '#80FF80', '#FF8096', '#800080'],
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '销售总额',
            type: 'pie',
            radius: '70%',
            data: [
              // { value: 1048, name: '自有商品销售额' },
              // { value: 735, name: 'Direct' },
              // { value: 580, name: 'Email' },
              // { value: 484, name: 'Union Ads' },
              // { value: 300, name: 'Video Ads' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      information: {
        "aggregateAmount": 0,
        "schoolQuantity": 0,
        "todayAggregateAmount": 0
      },
      rankingList: [],
      platformList: []
    }
  },
  components: {
  },
  methods: {
    // 获取今日新增运费和学校
    async freight() {
      const res = await request({
        method: 'GET',
        url: `admin/homePage/addSchoolAndFreightCost`
      })
      //console.log(res);
      if (res.code === '200') {
        // console.log(res);
        this.freightNum = res.data && res.data.freightCostMoney
        this.schoolNum = res.data && res.data.schoolQuantity
      } else {
        return
      }
    },
    // 获取今日订单
    async getOrderNum() {
      const res = await request({
        method: 'GET',
        url: `admin/homePage/todayNewOrder`
      })
      //console.log(res);
      if (res.code === '200') {
        this.addOrderNum = res.data
      } else {
        return
      }
    },
    // echarts图标
    generateEcharts() {
      let myChart = echarts.init(document.getElementById('home-main'));
      // 绘制图表
      myChart.setOption(this.option);
    },
    // 退款申请统计
    async getRefundStatistics() {
      const res = await request({
        method: 'GET',
        url: 'admin/homePage/refundApplicationCount'
      })
      // console.log(res);
      if (res.code === '200') {
        this.refundNum = res.data
      } else {
        return
      }
    },
    async getTotalAmount() {
      const res = await request({
        method: 'GET',
        url: 'admin/homePage/getGoodsAggregateAmount'
      })
      //console.log(res);
      if (res.code === '200') {
        this.option.series[0].data = [{ value: res.data.aggregateAmount, name: '自有商品销售额' }]
        //console.log(this.option);
        this.generateEcharts()
        res.data.todayAggregateAmount = "+" + res.data.todayAggregateAmount
        this.information = res.data
      }
    },
    async getGoodsSalesVolumeSum() {
      const res = await request({
        method: "GET",
        url: 'admin/homePage/getGoodsSalesVolumeSum'
      })
      //console.log(res);
      if (res.code === '200') {
        this.rankingList = res.data
      } else {
        return
      }
    },
    async getGoodsSalesRecommendSum() {
      const res = await request({
        method: "GET",
        url: 'admin/homePage/getGoodsSalesVolumeRecommendSum'
      })
      //console.log(res);
      if (res.code === '200') {
        this.platformList = res.data
      } else {
        return
      }
    },
  },
  created() {
    this.getOrderNum()
    this.getTotalAmount()
    this.getGoodsSalesVolumeSum()
    // this.getGoodsSalesRecommendSum()
    // this.getRefundStatistics()
    this.freight()
  },
  mounted() {
    // this.generateEcharts()
  }
}
</script>


<style lang="scss" scoped>
.home {
  height: 100%;
  overflow: auto;
}

.index {
  height: 150px;
  // background-color: #000;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 90px;

  .each-index {
    height: 100%;
    background-color: #E8E8E8;
    width: 18%;
    margin-right: 40px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px;

    div {

      i {
        display: inline-block;
        margin: 0 10px 10px 0;
      }
    }

    .line {
      display: block;
      width: 100%;
      height: 20px;
      overflow: hidden;
      margin-bottom: 20px;
    }

    .data {
      text-align: center;
      font-weight: bold;

      span {
        display: inline-block;
        margin-left: 10px;
        color: red;
        font-size: 20px;
      }
    }
  }

  .each-index.last {
    margin-right: 0 !important;
  }

}

#home-main {
  width: 40%;
  height: 400px;
  // background-color: aqua;
  // border: 1px solid #000;
  margin-right: 5%;
}

.cont {
  padding: 20px;
  height: 400px;
  margin: 30px auto 0;
  width: 90%;
  border: 1px solid #e0e0e0;
  // background-color: pink;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;

  .quota {
    width: 300px;
    height: 100%;
    // background-color: aqua;
    box-sizing: border-box;
    padding-top: 60px;
    margin-left: 10%;

    span {
      display: inline-block;
      height: 30px;
      line-height: 30px;
      font-size: 1.4rem;
      color: #666;
      margin-bottom: 10px;
    }

    p {
      height: 30px;
      line-height: 30px;
      font-size: 2.4rem;
      color: #000;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}

.table-box {
  display: flex;
  margin-top: 20px;
}

table {
  width: 40%;
  // height: 0px;
  margin: 10px auto 0;
  // table-layout: fixed;
  border-collapse: collapse;
  line-height: 25px;
  // color: blue;
}



table,
table tr,
table td {
  border: 1px solid #ccc;
  height: 20px;
}

table th {
  padding-top: 10px;
  background-color: #e0e0e0;

}

table td {
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>